export const DISPLAY_NAME_SUB_LABEL =
  "This will be displayed on your profile. If left blank, your username will be displayed.";
export const EMAIL_SUB_LABEL =
  "You can add an email to receive notifications about your auctions and bids (for instance, if you get outbid). This won’t be shown on your profile.";
export const USERNAME_SUB_LABEL =
  "This is your URL. Minimum 4 characters, periods and underscores are allowed.";
export const CATEGORY_SUB_LABEL =
  "Choose the category that best represents your project.";
export const COLOR_SCHEME_SUB_LABEL =
  "The color on the left will be the page background color, and the color on the right will be the highlight color.";
export const EMOJI_INPUT_SUB_LABEL =
  "This emoji will be used to mark how much progress has been made toward the goal.";
export const YOUTUBE_VIDEO_URL_SUBLABEL =
  "This is not required, but a compelling video can help people get a feel for who you are as a creator and why your campaign matters. If you add a video, it will show up as the first item in your campaign gallery.";
export const FUNDING_TIER_DESCRIPTION_SUB_LABEL =
  "A one-line description about the funding tier.";
export const FUNDING_TIER_BENEFITS_SUB_LABEL =
  "Describe the benefits that supporters of this funding tier will receive as part of your campaign.";
export const FUNDING_TIER_NFT_SUB_LABEL =
  "You'll be able to add NFTs to this funding tier after your campaign is reviewed.";
export const ABOUT_CAMPAIGN_SUB_LABEL =
  "Share more about the campaign and this project. What inspired you to do it, and what are your hopes for this project?";
export const ABOUT_CREATOR_SUB_LABEL =
  "Tell people about who you are as a creator, and why this campaign matters to you.";
export const ABOUT_PROJECT_GOALS_SUB_LABEL =
  "What do you plan to do with the funds raised in this project? ";
export const ABOUT_RISKS_AND_CHALLENGES_SUB_LABEL =
  "Help people understand what some of the obstacles and risks might be.";
export const CAMPAIGN_ABOUT_QUESTIONS_SUB_LABEL =
  "If people have other questions about your campaign, let them know how to reach you. For instance, you can provide an email address or a link to your Twitter messages.";
